import { Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useRemoveDeploymentGroup } from '@/queries/deploymentGroupQueries'
import { DeploymentGroup } from '@/types/deploymentGroup'
import { GroupCameraList } from './GroupCameraList'
import { GroupConfirmModal } from './GroupConfirmModal'
import { getGroupCameraNames } from './deploymentTreeHelpers'
import { DeploymentTreeGroupContext } from './deploymentTreeTypes'
import { useRunDeploymentAction } from './useRunDeploymentAction'

type GroupDeleteConfirmProps = {
  opened: boolean
  group: DeploymentGroup
  context: DeploymentTreeGroupContext
  onClose: () => void
}

export const GroupDeleteConfirm = ({
  opened,
  group,
  context,
  onClose
}: GroupDeleteConfirmProps) => {
  const { mutateAsync: removeGroup, isPending } = useRemoveDeploymentGroup()
  const run = useRunDeploymentAction(onClose)

  const names = getGroupCameraNames(group, context.device)

  const handleConfirm = () =>
    void run(() => removeGroup(group.id), {
      inProgress: 'deployments.groups.actions.delete.inProgress',
      error: 'deployments.groups.actions.delete.error'
    })

  return (
    <GroupConfirmModal
      opened={opened}
      title={<FormattedMessage id="deployments.groups.actions.delete.title" />}
      confirmLabel={
        <FormattedMessage id="deployments.groups.actions.delete.title" />
      }
      confirmColor="red"
      isPending={isPending}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Text size="sm">
        <FormattedMessage
          id="deployments.groups.actions.delete.confirmation"
          values={{
            number: context.label,
            device: context.deviceName,
            application: context.app.application_name,
            count: names.length
          }}
        />
      </Text>

      <GroupCameraList names={names} />
    </GroupConfirmModal>
  )
}
